/**
 *
 * Iframe
 *
 */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Button from 'ui/components/Button';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIframeState, makeSelectLoading, makeSelectError } from './selectors';
import { defaultAction } from './actions';
import reducer from './reducer';
import saga from './saga';
import routeTemplates from 'common/route-templates';
import queryString from 'query-string';
import styled from 'styled-components';

const IframePageContainer = styled.div`
  height: 100vh;
`;

const IframeWrapper = styled.iframe`
  width: 100vw;
  height: 100vh;
  border: none;
`;

export const Iframe = props => {
  useInjectReducer({ key: 'iframe', reducer });
  useInjectSaga({ key: 'iframe', saga });
  let iframeUrl = decodeURIComponent(queryString.parse(props.location.search).url);

  console.log(iframeUrl);

  return (
    <IframePageContainer>
      <IframeWrapper src={iframeUrl} />
    </IframePageContainer>
  );
};
Iframe.propTypes = {
  // defaultActionStart: PropTypes.func.isRequired,
};
export const mapStateToProps = (state, props) => {
  // @dev you can pass props to makeSelectFuncs(props) like so.
  return createStructuredSelector({
    iframe: makeSelectIframeState(),
    loading: makeSelectLoading(),
    error: makeSelectError(),
  });
};
export const mapDispatchToProps = dispatch => {
  /*
   * @dev - best practices for handling redux action
   * @params {object} payload - handle data to pass to api
   * @params {object} metadata - handle method, properties in redux-saga
   */
  return {
    defaultActionStart: ({ payload, metadata }) =>
      dispatch(defaultAction.start({ payload, metadata })),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(Iframe);
